import React from 'react';

import '../../../style/layout/BasicTabs.css';

export interface tabInfo {
  tabIcon: any;
  tabLabel: string;
  tabId: string;
}

const BasicTabBar = ({
  tabs,
  selectedTab,
  setSelectedTab,
}: {
  tabs: tabInfo[];
  selectedTab: string;
  setSelectedTab: (tab: string) => void;
}): JSX.Element | null => (
  <div className="tab-bar">
    {tabs.map((tab) => (
      <div
        className={
          selectedTab === tab.tabId
            ? 'tab-selector tab-selected'
            : 'tab-selector'
        }
        onClick={() => setSelectedTab(tab.tabId)}
        aria-hidden
        key={tab.tabId}
      >
        <p className="tab-text">{tab.tabLabel}</p>
      </div>
    ))}
  </div>
);

export default BasicTabBar;
